module.exports = __webpack_public_path__ + "centric-card-bottom-left@2x.3uiX-i28.png";